import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

const PreLoaderWidget = ({ isLoading, validationMsg }) => {
    if (isLoading) {
        return (
            <div className="preloader">
                <div className="status d-flex">
                    <div className="spinner-border avatar-sm text-primary m-2" role="status" />
                    {validationMsg && (
                        <span style={{ marginTop: '15px' }}>
                            <b>{validationMsg}</b>
                        </span>
                    )}
                </div>
            </div>
        );
    }
    return null;
};

const mapStateToProps = (state) => ({
    isLoading: state.loaderReducer.isLoading,
    validationMsg: state.loaderReducer.validationMsg,
});

PreLoaderWidget.propsTypes = {
    isLoading: PropTypes.bool.isRequired,
};
export default connect(mapStateToProps)(PreLoaderWidget);
